module.exports = __webpack_public_path__ + "img/otp-success.d08e6c34.png";